/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import tomatoes from "../../../assets/tomatoes.png";
import fallbackImage1 from "../../../assets/fallbackImage1.png";

// Interface for Card Props
interface CardProps {
  handleSeeMore?: (heading: string) => void;
  handleSeeMoreOnKeyPress?: (heading: string, e?: any) => void;
  title?: any;
  description?: any;
  imageUrl?: string;
  type?: string;
  needStateImages?: any;
  foodSubType?: any;
  t?: any;
}

// Interface for Card State
interface CardState {
  // isPopupOpen: boolean;
  //stateItem: any;
}

/**
 * Card component.
 *
 * @namespace Card
 */
class Card extends React.Component<CardProps, CardState> {
  constructor(props: CardProps) {
    super(props);
    this.state = {
      isPopupOpen: false,
      // stateItem: [],
    };
  }

  // componentDidUpdate = () => {
  //   if (this.props.item !== this.state.stateItem) {
  //     this.setState({ stateItem: this.props.item });
  //   }
  // };

  render() {
    const { title, imageUrl, type, description, foodSubType } = this.props;

    const needStateInfo: any =
      localStorage.getItem("results-info") !== "undefined" &&
      localStorage.getObj("results-info")?.need_state;
    const fallBackImageCard: any =
      localStorage.getItem("results-info") !== "undefined" &&
      localStorage.getObj("results-info")?.fallbackimagecard?.url;

    // const sample =
    //   "https://images.contentstack.io/v3/assets/blt4b278b71ba191081/blt4811a7fbf77b4083/5f21be8962b9285a38baf444/leaves.png";

    return (
      <>
        <div
          className="white-cards"
          onClick={() =>
            this.props.handleSeeMore && this.props.handleSeeMore("why")
          }
          //onKeyPress={(e) => this.props.handleSeeMoreOnKeypres && this.props.handleSeeMoreOnKeypres(e, "why")}
        >
          <div className="inner-wrapper">
            {/* {imageUrl && ( */}
            <div
              tabIndex={-1}
              aria-label={title}
              role="img"
              className="card-image icon"
              // style={{
              //   backgroundImage: `url(${imageUrl}))`,
              // }}
              style={{
                backgroundImage: imageUrl
                  ? `linear-gradient(
                    144.21deg,
                    rgba(44, 44, 44, 0.8) 8.4%,
                    rgba(44, 44, 44, 0) 41.65%),url(${imageUrl})`
                  : `url(${fallBackImageCard})`,
              }}
            >
              {this.props.needStateImages &&
                this.props.needStateImages.length > 0 &&
                !_.isEmpty(needStateInfo) && (
                  <div className="card-icons">
                    {/* <div className="icon custom-icon"></div>
                <div className="icon custom-icon"></div>
                <div className="icon custom-icon"></div> */}
                    {this.props.needStateImages.map((item: any, index: any) => (
                      // JSON.stringify(
                      //   needStateInfo[item?.replaceAll("-", "_")][2]
                      // )
                      <div
                        key={index}
                        className="icon custom-icon"
                        style={{
                          backgroundImage:
                            needStateInfo[
                              item && item?.replaceAll("-", "_")
                            ]?.[3] &&
                            `url(${
                              needStateInfo[
                                item && item?.replaceAll("-", "_")
                              ][3]
                            })`,
                          // : `url(${tomatoes})`,
                        }}
                      />
                    ))}
                  </div>
                )}
            </div>
            {/* )} */}
            <div className="card-details-wrapper">
              <div className="details">
                <div className="title">{title ? title : ""}</div>
                <div className="description">
                  {description ? description : ``}
                </div>
              </div>
              <div
                tabIndex={0}
                role="link"
                className="see-more"
                onClick={(e: any) => {
                  e.stopPropagation();
                  this.props.handleSeeMore &&
                    this.props.handleSeeMore(
                      type === "tips"
                        ? "where"
                        : type === "foods" && foodSubType === "avoid"
                        ? "why"
                        : "why"
                    );
                }}
                onKeyPress={(e: any) => {
                  e.stopPropagation();
                  this.props.handleSeeMoreOnKeyPress &&
                    this.props.handleSeeMoreOnKeyPress(
                      type === "tips"
                        ? "where"
                        : type === "foods" && foodSubType === "avoid"
                        ? "why"
                        : "why",
                      e
                    );
                }}
              >
                {type === "tips"
                  ? this.props.t("common.where_to_start")
                  : type === "foods" && foodSubType === "avoid"
                  ? this.props.t("common.see_why")
                  : this.props.t("common.see_why")}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Card;
